module.exports = __webpack_public_path__ + "static/media/info.688d457c.svg";